import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Constants
import constants from "./constants/scroll.constants";
var scrollFromTop = function scrollFromTop() {
  var _document, _document$body;
  var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : +((_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollHeight);
  return window.scrollTo(_objectSpread({
    top: top
  }, constants.SCROLL_PARAMS));
};
var scrollToTop = function scrollToTop() {
  return window.scrollTo(constants.SCROLL_TOP_PARAMS);
};
var windowHasVerticalScroll = function windowHasVerticalScroll() {
  return window.scrollY > 0;
};
var existsScrollOnBody = function existsScrollOnBody() {
  var _document$body2;
  return +((_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : _document$body2.scrollHeight) > +window.innerHeight;
};
var windowHasHorizontalScroll = function windowHasHorizontalScroll() {
  return window.scrollX > 0;
};
export default {
  existsScrollOnBody: existsScrollOnBody,
  scrollFromTop: scrollFromTop,
  scrollToTop: scrollToTop,
  windowHasHorizontalScroll: windowHasHorizontalScroll,
  windowHasVerticalScroll: windowHasVerticalScroll
};